const actionTypes = require('constants/actionTypes');
const { APIPost } = require('utilities/APIRequestHelper');

const registerDocumentsRequest = () => ({
    type: actionTypes.CONTRACT_METHOD_REGISTER_PRODUCT_DOCUMENTS_REQUEST,
});

const registerDocumentsSuccess = () => ({
    type: actionTypes.CONTRACT_METHOD_REGISTER_PRODUCT_DOCUMENTS_SUCCESS,
});

const registerDocumentsFailure = () => ({
    type: actionTypes.CONTRACT_METHOD_REGISTER_PRODUCT_DOCUMENTS_FAILURE,
});

const registerDocuments = (requestData) => (dispatch) => {
    dispatch(registerDocumentsRequest());
    return APIPost({
            dispatch,
            endpoint: 'registerDocumentsDeposit',
            params: requestData,
        })
        .then(() => dispatch(registerDocumentsSuccess()))
        .catch(response => {
            if (!!response.error) {
                dispatch(registerDocumentsFailure());
            } else {
                throw response;
            }
        }
    );
}

module.exports = {
    registerDocuments
};
